import { ReactElement } from 'react';

import {
   CurrentHealthcareProviderAvailableReceptionServiceQuery,
   ReceptionService,
} from '@dreryk/egabinet-patient-portal-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { boundServiceTranslationKeys } from '../../../translations';

import { HealthcareProviderPatientPortalBoundServiceCreateFormController } from './healthcareProviderPatientPortalBoundServiceCreate.types';

const receptionServiceWithPractitionerSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<ReceptionService[]> =>
      performCqrsQuerySearch<ReceptionService>(() => {
         const query = new CurrentHealthcareProviderAvailableReceptionServiceQuery();
         query.name = searchText ? TextPattern.anywhereIgnoreCase(searchText) : TextPattern.any();
         return query;
      });
};

const triggerLabelExtractor = (receptionService: ReceptionService): string => receptionService.name;

type ReceptionServiceSelectProps = {
   readonly register: HealthcareProviderPatientPortalBoundServiceCreateFormController['register'];
};

export const ReceptionServiceSelect = (props: ReceptionServiceSelectProps): ReactElement => {
   return (
      <Select<ReceptionService>
         testId={'receptionService'}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register('receptionService', { required: true })}
         placeholder={boundServiceTranslationKeys.chooseReceptionService}
         label={boundServiceTranslationKeys.receptionService}
         searchInputEnabled
      >
         <Select.SearchCreator searchCreator={receptionServiceWithPractitionerSearchCreator}>
            {({ items: services }) => (
               <Select.List<ReceptionService> items={services} keyExtractor={'id'}>
                  {(service) => (
                     <Select.Item
                        item={service}
                        testId={service.name}
                        label={<Select.Highlight node={createTranslatedText(service.name)} />}
                     />
                  )}
               </Select.List>
            )}
         </Select.SearchCreator>
      </Select>
   );
};
